
const baseObjectGroups  = [
    { id: 'app', name: 'App', mainClass: '.advCSS-app' },
    { id: 'page', name: 'Page', mainClass: '.advCSS-page' },
    { id: 'texts', name: 'Texts & Headings', mainClass: '.advCSS-basetext, .advCSS-text, .advCSS-smalltext, .advCSS-largeheading, .advCSS-mediumheading, .advCSS-smallheading, .advCSS-link, .advCSS-bullettext' },
    { id: 'inputs', name: 'Inputs', mainClass: '.advCSS-baseinput,.advCSS-textinput,.advCSS-textarea,.advCSS-numericinput,.advCSS-dateinput,.advCSS-timeinput,.advCSS-passwordinput,.advCSS-masktextinput,.advCSS-dropdown,.advCSS-list,.advCSS-numericstepper' },
    { id: 'buttons', name: 'Buttons', mainClass: '.advCSS-basebutton,.advCSS-button,.advCSS-submitbutton,.advCSS-pagebutton,.advCSS-printbutton,.advCSS-playnewbutton,.advCSS-playreportbutton' },
    { id: 'selection', name: 'Selection & Choice', mainClass: '.advCSS-tickbox,.advCSS-radiobutton' },
    { id: 'groups', name: 'Groups', mainClass: '.advCSS-group' },
    { id: 'tables', name: 'Tables', mainClass: '.advCSS-tableContainer,.advCSS-col-button,.advCSS-col-checkbox,.advCSS-col-childappbutton,.advCSS-col-dateinput,.advCSS-col-dropdown,.advCSS-col-fileattachment,.advCSS-col-numericinput,.advCSS-col-radiobutton,.advCSS-col-textarea,.advCSS-col-textinput,.advCSS-col-timeinput' },
    { id: 'picture', name: 'Picture', mainClass: '.advCSS-picture' },
    { id: 'fileAttachment', name: 'File Attachment', mainClass: '.advCSS-fileattachment' },
    { id: 'calendar', name: 'Date Calendar', mainClass: '.advCSS-datecalendar' },
    { id: 'webSignature', name: 'Web Signature', mainClass: '.advCSS-websignature' },
    { id: 'sliders', name: 'Sliders', mainClass: '.advCSS-baseslider, .advCSS-verticalslider, .advCSS-horizontalslider' },
    { id: 'separators', name: 'Separators', mainClass: '.advCSS-baseseparator, .advCSS-verticalseparator, .advCSS-horizontalseparator' },
    { id: 'progressBar', name: 'Progress Bar', mainClass: '.advCSS-progressbar' },
];

const reportingGroup = { 
    id: 'reporting', 
    name: 'Reporting', 
    mainClass: '.advCSS-clearfilterbutton,.advCSS-crosstab, .advCSS-datagrid, .advCSS-datalist, .advCSS-filterinput, .advCSS-filterselector, .advCSS-value'
};

export const getObjectGroups = (isReport) => {
    const groups = [...baseObjectGroups];

    if (isReport) {
        groups.push(reportingGroup);
    }
    
    return groups;
};

export const cssTemplates = {
    app:
`/* Styles for the main app. Please use !important to correctly override. */
.advCSS-app {

}`,
    page:
`/* Styles for the main page container. Please use !important to correctly override. */
.advCSS-page {

}`,
    texts:
`/* Styles for all text and heading types. Please use !important to correctly override. */

.advCSS-basetext { /* Base styles for all text */

}
.advCSS-text { /* Standard text */

}
.advCSS-smalltext { /* Small text */

}
.advCSS-largeheading { /* Large heading */

}
.advCSS-mediumheading { /* Medium heading */

}
.advCSS-smallheading { /* Small heading */

}
.advCSS-link { /* Link styles */

}
.advCSS-link:hover { /* Link hover state */

}
.advCSS-bullettext{ /* Bullet text */

}
.advCSS-bullettext li{ /* Bullet text item*/

}
`,
    inputs:
`/* Styles for all input types. Please use !important to correctly override. */

.advCSS-baseinput { /* Base styles for all inputs */

}
.advCSS-textinput { /* Single line text input */

}
.advCSS-textarea { /* Multi-line text area */

}
.advCSS-numericinput { /* Numeric input */

}
.advCSS-dateinput { /* Date input */

}
.advCSS-timeinput { /* Time input */

}
.advCSS-passwordinput { /* Password input */

}
.advCSS-masktextinput { /* Masked text input */

}
.advCSS-dropdown { /* Dropdown / Select list */

}
.advCSS-list { /* List box */

}
.advCSS-numericstepper { /* Numeric Stepper */

}`,
    buttons:
`/* Styles for all button types. Please use !important to correctly override. */

.advCSS-basebutton { /* Base styles for all buttons */

}
.advCSS-basebutton:hover { /* Base hover state */

}
.advCSS-button { /* Standard button */

}
.advCSS-submitbutton { /* Submit button */

}
.advCSS-pagebutton { /* Next/Prev page button */

}
.advCSS-printbutton { /* Print button */

}
.advCSS-playnewbutton { /* "Show App" button */

}
.advCSS-playreportbutton { /* "Show Report" button */

}`,
    selection:
`/* Styles for selection controls. Please use !important to correctly override. */

.advCSS-tickbox { /* Checkbox styles */

}
.advCSS-radiobutton { /* Radio button styles */

}`,
    groups:
`/* Styles for group containers. Please use !important to correctly override. */
.advCSS-group {

}

.advCSS-group .groupTitle { /* Group title bar */

}`,
tables:
`/* Styles for the main table wrapper. Please use !important to correctly override. */
.advCSS-tableContainer {
    
}
.advCSS-tableContainer table {
    
}
.advCSS-tableContainer thead {
    
}
.advCSS-tableContainer th {
    
}
.advCSS-tableContainer tbody tr {
    
}
.advCSS-tableContainer tbody tr:hover {
    
}
.advCSS-tableContainer tbody td {
    
}

/* --- Styles for specific column types --- */

.advCSS-col-button {

}

.advCSS-col-checkbox {

}

.advCSS-col-childappbutton {

}

.advCSS-col-dateinput {

}

.advCSS-col-dropdown {

}

.advCSS-col-fileattachment {

}

.advCSS-col-numericinput {

}

.advCSS-col-radiobutton {

}

.advCSS-col-textarea {

}

.advCSS-col-textinput {

}

.advCSS-col-timeinput {

}`,
    picture:
`/* Styles for picture/image elements. Please use !important to correctly override. */
.advCSS-picture {

}`,
    fileAttachment:
`/* Styles for the file attachment component. Please use !important to correctly override. */
.advCSS-fileattachment { /* Main container */

}
.advCSS-fileattachment .AttachButton { /* Attach button */

}
.advCSS-fileattachment .DetachButton { /* Detach button */

}`,
    calendar:
`/* Styles for the date calendar widget. Please use !important to correctly override. */
.advCSS-datecalendar {

}
.advCSS-datecalendar .ui-datepicker-header {

}
.advCSS-datecalendar .ui-state-default {

}`,
    webSignature:
`/* Styles for the web signature component. Please use !important to correctly override. */
.advCSS-websignature { /* Main container */

}
.advCSS-websignature .signarea { /* Signature canvas area */

}
.advCSS-websignature .saveButton { /* Save button */

}
.advCSS-websignature .clearButton { /* Clear button */

}`,
    sliders:
`/* Styles for slider controls. Please use !important to correctly override. */

.advCSS-baseslider { /* Base styles for all sliders */

}
.advCSS-verticalslider { /* Vertical slider */

}
.advCSS-horizontalslider { /* Horizontal slider */

}`,
    separators:
`/* Styles for separator lines. Please use !important to correctly override. */

.advCSS-baseseparator { /* Base styles for all separators */

}
.advCSS-verticalseparator { /* Vertical line */

}
.advCSS-horizontalseparator { /* Horizontal line */

}`,
    progressBar:
`/* Styles for the progress bar. Please use !important to correctly override. */
.advCSS-progressbar { /* The main container */

}
.advCSS-progressbar .ui-progressbar-value { /* The colored fill bar */

}`,
    reporting:
`/* Styles for reporting components. Please use !important to correctly override. */
.advCSS-clearfilterbutton {

}
.advCSS-crosstab {

}
.advCSS-datagrid {

}
.advCSS-datalist {

}
.advCSS-filterinput {

}
.advCSS-filterselector {

}
.advCSS-value {

}`,
};